import { t, Trans } from '@lingui/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { TireOfferV2 } from 'noddi-types';
import { NoddiBasicCard, NoddiTabsV2 } from 'noddi-ui-web';
import { getCarDisplayName } from 'noddi-util';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import ContentWrapperWithQuery from '../../components/Layouts/ContentWrapperWithQuery';
import { TireOfferStatusChip } from '../../components/TireOffer/TireOfferStatusChip';
import { StatusUpdates } from './StatusUpdates';
import { TireOrderDetails } from './TireOrderDetails';

enum StepKey {
  STATUS_UPDATES = 'status-updates',
  ORDER_DETAILS = 'order-details'
}

function getTabItems(tireOffer: TireOfferV2) {
  return [
    {
      label: t`Updates`,
      value: StepKey.STATUS_UPDATES,
      node: <StatusUpdates tireOffer={tireOffer} />
    },
    {
      label: t`Order details`,
      value: StepKey.ORDER_DETAILS,
      node: <TireOrderDetails tireOffer={tireOffer} />
    }
  ];
}

export const TireOfferStatus = () => {
  const { slug } = useParams() as { slug: string };
  const [activeTab, setActiveTab] = useState(StepKey.STATUS_UPDATES);

  const query = noddiAsync.useGet({
    type: URLKeys.getCarTireQuoteBySlug,
    input: { slug },
    queryConfig: { staleTime: Infinity }
  });

  return (
    <ContentWrapperWithQuery widerScreen hideBackButton query={query} title={t`Your tire order`}>
      {({ data }) => {
        const season = data.season.value === 0 ? t`summer tires` : t`winter tires`;
        const carName = getCarDisplayName(data.car);
        const translatedSeasonTitle = t`New ${season} for`;

        return (
          <div className='flex flex-col gap-4'>
            <div className='flex flex-col md:flex-row md:gap-1 md:text-4.5'>
              <p>{translatedSeasonTitle}</p>
              <p className='font-bold'> {carName}</p>
            </div>
            <NoddiBasicCard className='p-0'>
              <div className='flex flex-col gap-4 border-b border-grey/30 px-5 py-4 md:flex-row md:items-center md:justify-between'>
                <p className='text-4.5'>
                  <Trans>Order status</Trans>
                </p>
                <TireOfferStatusChip tireOffer={data} />
              </div>

              <div className='flex flex-col gap-4 px-5 py-4'>
                <NoddiTabsV2<StepKey> items={getTabItems(data)} value={activeTab} onChange={setActiveTab} />
              </div>
            </NoddiBasicCard>
          </div>
        );
      }}
    </ContentWrapperWithQuery>
  );
};
